import { createAxiosInstance } from '@kc-console/core';

import env from '../../utils/env';
import { getMetaApiFetchers } from './getMetaApiFetchers';

import type { AxiosRequestConfig } from 'axios';
import type { HttpClientTimingObserver } from '@kc-console/core';

type MetaApiInstanceReqParams = {
  metaEndpoint?: string;
  onHttpTiming?: HttpClientTimingObserver;
  overrideAxiosRequestConfig?: AxiosRequestConfig;
  requestId?: string;
  token?: string;
};

const metaApiInstance = (params: MetaApiInstanceReqParams) => {
  const {
    metaEndpoint = env.KC_META_ENDPOINT || '',
    token = '',
    onHttpTiming,
    overrideAxiosRequestConfig,
    requestId,
  } = params;
  const axiosInstance = createAxiosInstance({
    token,
    requestId,
    onHttpTiming,
    overrideAxiosRequestConfig,
    baseURL: metaEndpoint,
    isCancel: !metaEndpoint,
  });
  return getMetaApiFetchers(axiosInstance);
};

export default metaApiInstance;
